export class OperatorViewModel {
  public operator: any = {};
  public pageLoading: boolean = false;
  public pageLoadingError: string = "";

  public title = "";
}
